import React from 'react';
import UserProfileContainer from '../containers/UserProfile/userProfile';

const UserProfile = () => <UserProfileContainer />;

export default UserProfile;
